import React, { useState, useEffect } from 'react';
import { useCheckUserRole } from '../pages/hooks/useCheckUserRole';

function CommentSection({ blogId }) {
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState("");
    const [newReply, setNewReply] = useState({});
    const [replyVisibility, setReplyVisibility] = useState({});
    const [isBlocked, setIsBlocked] = useState(false);  // Block status is fetched with comments
    useCheckUserRole(['admin', 'editor', 'user']); 

    useEffect(() => {
        // Tek bir API çağrısında hem yorumlar hem de engel durumu bilgisi alınır
        fetch(`/api/blogs/${blogId}/comments`)
            .then(response => response.json())
            .then(data => {
                setComments(data.comments);  // Yorumlar
                setIsBlocked(data.is_blocked);  // Engelli kullanıcı durumu
            })
            .catch(error => console.error('Error fetching comments:', error));
    }, [blogId]);

    const handleCommentSubmit = (e) => {
        e.preventDefault();
        fetch(`/api/blogs/${blogId}/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ content: newComment }),
        })
        .then(response => response.json())
        .then(() => {
            setNewComment("");
            return fetch(`/api/blogs/${blogId}/comments`);
        })
        .then(response => response.json())
        .then(data => setComments(data.comments))
        .catch(error => console.error('Error posting comment:', error));
    };

    const handleReplySubmit = (e, parentId) => {
        e.preventDefault();
        fetch(`/api/blogs/${blogId}/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ content: newReply[parentId], parent_id: parentId }),
        })
        .then(response => response.json())
        .then(() => {
            setNewReply({ ...newReply, [parentId]: "" });
            setReplyVisibility({ ...replyVisibility, [parentId]: false });
            return fetch(`/api/blogs/${blogId}/comments`);
        })
        .then(response => response.json())
        .then(data => setComments(data.comments))
        .catch(error => console.error('Error posting reply:', error));
    };

    const toggleReplyVisibility = (commentId) => {
        setReplyVisibility(prev => ({ ...prev, [commentId]: !prev[commentId] }));
    };

    return (
        <div className="comment-section">
            <h3>Yorumlar</h3>
            <ul>
                {comments.map(comment => (
                    <li key={comment.id}>
                        <p>{comment.content} - <strong>{comment.author}</strong> on {new Date(comment.date).toLocaleDateString()}</p>
                        <ul>
                            {comment.replies.map(reply => (
                                <li key={reply.id}>
                                    <p>{reply.content} - <strong>{reply.author}</strong> on {new Date(reply.date).toLocaleDateString()}</p>
                                </li>
                            ))}
                        </ul>
                        <button onClick={() => toggleReplyVisibility(comment.id)}>Yanıtla</button>
                        {replyVisibility[comment.id] && (
                            <form onSubmit={(e) => handleReplySubmit(e, comment.id)}>
                                <input
                                    type="text"
                                    value={newReply[comment.id] || ""}
                                    onChange={(e) => setNewReply({ ...newReply, [comment.id]: e.target.value })}
                                    placeholder="Reply..."
                                />
                                <button type="submit">Gönder</button>
                            </form>
                        )}
                    </li>
                ))}
            </ul>

            {!isBlocked && (  // Sadece engellenmemiş kullanıcılar yorum formunu görebilir
                <form onSubmit={handleCommentSubmit}>
                    <input
                        type="text"
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        placeholder="Add a comment..."
                    />
                    <button type="submit">Yorum Yap</button>
                </form>
            )}
        </div>
    );
}

export default CommentSection;
